// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"43":"refundpolicy","137":"bookonline","192":"booknow","240":"booking","309":"termsandconditions","898":"bookingdetails","987":"privacypolicy"}[chunkId] + "." + {"43":"95421705","137":"355a9780","192":"bf802568","240":"3c2d708a","309":"f471e685","898":"96679f19","987":"6b259229"}[chunkId] + ".css";
};